import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { CasinoGameDeviceType } from '../../../../casino/Api/Models/CasinoGame';
import DeleteButton from '../../../elements/DeleteButton';
import axios from '../../../services/MyAxios';
import GameSearchInput from '../../elements/GameSearchInput';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';

function TournamentEditGames() {
    const { id } = useParams();
    const url = `/crea/casino/api/tournaments/${id}/games`;
    const deleteUrl = `/crea/casino/api/tournaments/${id}/games/remove`;

    const [tournamentGames, setTournamentGames] = useState({
        tournament: {
            id: 0,
            name: '',
            slug: '',
        },
        games: {
            desktop: {
                id: 0,
                name: '',
                provider: '',
                is_mobile: false,
            },
            mobile: {
                id: 0,
                name: '',
                provider: '',
                is_mobile: false,
            },
        },
    });

    function getTournamentGames() {
        axios.get(url).then((response) => {
            setTournamentGames(response.data);
        });
    }

    useEffect(() => {
        getTournamentGames();
    }, []);

    function generateTable(type) {
        return (
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title text-capitalize font-weight-bold">{type} games</h4>
                    <div className="d-flex flex-wrap">
                        {tournamentGames.games[type] && tournamentGames.games[type].length > 0 ? (
                            tournamentGames.games[type].map((game) => {
                                return (
                                    <div className="card" style={{ width: '20%', padding: '6px' }} key={game.id}>
                                        <img className="card-img-top" src={game.image} alt={game.name} />
                                        <div className="card-body">
                                            <h5>{game.creator_name}</h5>
                                            <h4 className="card-title" style={{ height: '60px' }}>
                                                {game.name}
                                            </h4>
                                            <DeleteButton
                                                url={`${deleteUrl}/${game.id}`}
                                                action={() => getTournamentGames()}
                                                permissions={[CRM_PERMISSION.TOURNAMENT_EDIT]}
                                                key="delete"
                                            />
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <span className="text-danger">Tournament does not have any games for {type} device.</span>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <GameSearchInput
                action={() => getTournamentGames()}
                insertUrl={`/crea/casino/api/tournaments/${id}/games/insert`}
            />
            <div className="card">{generateTable(CasinoGameDeviceType.DESKTOP)}</div>
            <div className="card">{generateTable(CasinoGameDeviceType.MOBILE)}</div>
        </div>
    );
}

export default TournamentEditGames;
